// Settings module to hold feature flags and app-level settings.
// This provides a minimal, safe implementation so components that
// dispatch settings/fetchSettings or read inactivitySettings won't fail.
const defaults = {
  // feature flags
  // feature_flags: {
  //   file_fast_detail: process.env.VUE_APP_FEATURE_FILE_FAST === "true" || false,
  // },

  // inactivity settings used by appBar
  inactivitySettings: {
    inactivityEnabled: false,
    inactivityLimit: 30, // seconds
    warningDelayLimit: 20, // seconds
  },
};

const state = {
  feature_flags: { ...defaults.feature_flags },
  inactivitySettings: { ...defaults.inactivitySettings },
  // raw settings (could be extended later)
  settingsRaw: {},
};

const getters = {
  isFileFastEnabled: (s) => !!s.feature_flags.file_fast_detail,
  inactivitySettings: (s) =>
    s.inactivitySettings || defaults.inactivitySettings,
};

const mutations = {
  setFeatureFlag(state, { key, value }) {
    state.feature_flags = { ...state.feature_flags, [key]: value };
  },
  setInactivitySettings(state, payload) {
    state.inactivitySettings = { ...state.inactivitySettings, ...payload };
  },
  setSettingsRaw(state, payload) {
    state.settingsRaw = payload || {};
  },
};

const actions = {
  // Minimal fetchSettings action: attempt to read from a backend endpoint
  // if available, otherwise fallback to defaults. Returning a promise so
  // callers can await this dispatch.
  async fetchSettings({ commit }) {
    // Load settings from backend if endpoint exists. On failure fall back to defaults.
    const axios = require("axios");
    const { apiConfig } = require("@/config/api.config");
    try {
      const res = await axios.get(`${apiConfig.baseURL}/settings/management`);
      const data = res.data || {};
      // store raw settings so other modules can inspect if needed
      commit("setSettingsRaw", data);
      // Build inactivity settings object from backend payload (use defaults for missing fields)
      const inactivity = {
        inactivityEnabled: !!data.inactivityEnabled,
        inactivityLimit:
          typeof data.inactivityLimit !== "undefined"
            ? Number(data.inactivityLimit)
            : defaults.inactivitySettings.inactivityLimit,
        warningDelayLimit:
          typeof data.warningDelayLimit !== "undefined"
            ? Number(data.warningDelayLimit)
            : defaults.inactivitySettings.warningDelayLimit,
      };
      commit("setInactivitySettings", inactivity);
      return Promise.resolve();
    } catch (e) {
      console.error("settings.fetchSettings failed, using defaults", e);
      commit("setSettingsRaw", {});
      commit("setInactivitySettings", defaults.inactivitySettings);
      return Promise.resolve();
    }
  },

  setFeatureFlag({ commit }, payload) {
    commit("setFeatureFlag", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
